import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoadingFile: false,
  isPrintServiceUnavailable: false,
  isVendor: false,
  isSaleInProgress: false,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  selectors: {
    GET_APP_STATE: createSelector([(state) => state], (state) => {
      return {
        app: {
          isLoadingFile: state?.isLoadingFile,
          isPrintServiceUnavailable: state?.isPrintServiceUnavailable,
          isVendor: state?.isVendor,
          isSaleInProgress: state?.isSaleInProgress,
        },
      };
    }),
  },
  reducers: {
    SET_IS_LOADING_FILE: (state, action) => {
      state.isLoadingFile = action.payload;
    },
    SET_IS_PRINT_SERVICE_UNAVAILABLE: (state, action) => {
      state.isPrintServiceUnavailable = action.payload;
    },
    SET_IS_VENDOR: (state, action) => {
      state.isVendor = action.payload;
    },
    SET_IS_SALE_IN_PROGRESS: (state, action) => {
      state.isSaleInProgress = action.payload;
    },
  },
});

export const {
  SET_IS_LOADING_FILE,
  SET_IS_PRINT_SERVICE_UNAVAILABLE,
  SET_IS_VENDOR,
  SET_IS_SALE_IN_PROGRESS,
} = appSlice.actions;
export const { GET_APP_STATE } = appSlice.selectors;
export default appSlice.reducer;
